import { useQuery } from "@tanstack/react-query";
import {
  HistoricQuotesApiHistoricQuotesRequest,
  buildHistoricQuotesApi,
} from "@rentablo/api/apiv1";
import { UseQueryExtendedOptions, useQueryHandler } from "@rentablo/api";
import { HistoricQuote } from "@api";
import { HISTORIC_QUOTES } from "@api/cacheKeys";

const getHistoricQuotes = async (
  tickerSymbol: string | string[] | undefined,
  attrs: Omit<HistoricQuotesApiHistoricQuotesRequest, "tickerSymbol"> = {}
): Promise<{ [key: string]: HistoricQuote[] }> => {
  if (!tickerSymbol) {
    return {};
  }

  const normalizedTickerSymbol = Array.isArray(tickerSymbol)
    ? tickerSymbol
    : [tickerSymbol];
  const historicQuotesApi = buildHistoricQuotesApi();
  const { data } = await historicQuotesApi.historicQuotes({
    tickerSymbol: normalizedTickerSymbol,
    ...attrs,
  });

  return (data.historicQuotes ?? {}) as { [key: string]: HistoricQuote[] };
};

export const useHistoricQuotesByTicker = (
  tickerSymbol: string | string[] | undefined,
  attrs?: Omit<HistoricQuotesApiHistoricQuotesRequest, "tickerSymbol">,
  options?: UseQueryExtendedOptions<
    unknown,
    AxiosApiError,
    { [key: string]: HistoricQuote[] },
    (
      | string
      | string[]
      | Omit<HistoricQuotesApiHistoricQuotesRequest, "tickerSymbol">
      | undefined
    )[]
  >
) => {
  return useQueryHandler({
    query: useQuery({
      queryKey: [HISTORIC_QUOTES, tickerSymbol, attrs],
      queryFn: () => getHistoricQuotes(tickerSymbol, attrs),
      ...options,
    }),
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  });
};
